import React from 'react';
import { Skeleton, SkeletonProps } from '@material-ui/lab';

import useStyles from './Skeleton.style';

export interface CustomSkeletonProps extends SkeletonProps {
  className?: string;
}

const CustomSkeleton: React.FC<CustomSkeletonProps> = ({ children, ...props}) => {
  const c = useStyles({ });

  return (
    <Skeleton {...props} classes={{ root: c.root }}>
      {children}
    </Skeleton>
  );
};

export default CustomSkeleton;
